module.exports = __webpack_public_path__ + "img/Previeweyezen-boost_smartphone.c37f1690.png";